import { EntityDescriptor } from '../business-logic';
import { scheduledLegSchema } from '../schemas/scheduledLeg';

export const scheduledLegEntity: EntityDescriptor = {
	scheduledLeg: {
		migrationStrategies: {
			1: function (oldDoc: any) {
				// migration to rxdb 12
				return oldDoc;
			},
			2: function (oldDoc: any) {
				// Add note field for driver notices
				oldDoc.note = null;
				return oldDoc;
			},
			3: function (oldDoc: any) {
				/**
				 * New fields added:
				 *  * enteringBookingLegs
				 *  * exitingBookingLegs
				 * */
				oldDoc.note = null;
				return oldDoc;
			},
			4: function (oldDoc: any) {
				/**
				 * New fields added:
				 *  * estimatedStart
				 *  * estimatedEnd
				 *  * consideredDelayed
				 * */
				return oldDoc;
			},
		},
		schema: scheduledLegSchema,
	},
};
